<template>
  <!-- 远程控制 -->
  <div class="FilesManage">
    <div class="con">
      <div class="left-tree">
        <elAreaTree :dataList='dataList'></elAreaTree>
      </div>
      <div class="right-table">
        <div class="content">
          <div class="Files-top">
            <div class="ic-left">
              <span>档案管理</span>
            </div>

            <!-- <div class="ic-left">
              <span>开合闸状态：</span>
              <el-select v-model="temp.roleTypeId" placeholder="请选择" style="width: 150px; margin-right: 10px;">
                <el-option v-for="item in roleOptions" :key="item.id" :label="item.roleName" :value="item.id">
                </el-option>
              </el-select>
              <span>表编号：</span>
              <el-input v-model="seraname" size="small" style="width: 150px; margin-right: 10px;"></el-input>
              <span>表种类：</span>
              <el-input v-model="seraname" size="small" style="width: 150px; margin-right: 10px;"></el-input>
              <span>表型号：</span>
              <el-input v-model="seraname" size="small" style="width: 150px; margin-right: 10px;"></el-input>
              <el-button type="primary" size="mini" plain @click="add_ed" style="margin-left:15px">查询</el-button>
            </div>-->
            <div class="btns">
              <el-upload action="" :show-file-list="false" :auto-upload="false"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                list-type="picture-card" :on-change="saveExcel_fn">
                <el-button type="primary" size="mini" style="height:32px;margin:0px 15px">按所选中片区发送</el-button>
              </el-upload>
              <el-button type="primary" size="mini" @click="add_ed" class="last-el-button">按所选中的表发送</el-button>
            </div>


          </div>
          <div class="search-input-btn">
            <div class="input-small">
              <span>开合闸状态：</span>
              <el-select v-model="temp.roleTypeId" placeholder="请选择" style="width: 150px; margin-right: 20px;">
                <el-option v-for="item in roleOptions" :key="item.id" :label="item.roleName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="input-small">
              <span>表编号：</span>
              <el-input v-model="seraname" style="width: 150px; margin-right: 20px;"></el-input>
            </div>
            <div class="input-small">
              <span>表种类：</span>
              <el-input v-model="seraname" style="width: 150px; margin-right: 20px;"></el-input>
            </div>
            <div class="input-small">
              <span>表型号：</span>
              <el-input v-model="seraname" style="width: 150px;"></el-input>
            </div>
            <el-button type="primary" size="mini" plain @click="add_ed" class="search-btn">查询</el-button>
          </div>
          <div class="Files-table" :style="{'height':heights+'px'}">
            <el-table :data="tableData" stripe style="width: 100%" :max-height="heights - 20">
              <template slot="empty">
                <span class="noData">
                  <img src="../../assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column label="序号" width="90" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cardNum" label="表编号" width="180" align="center"> </el-table-column>
              <el-table-column prop="cardNum" label="表种类" width="180" align="center"> </el-table-column>
              <el-table-column prop="cardNum" label="表型号" width="180" align="center"> </el-table-column>
              <el-table-column prop="cardNum" label="开合状态" width="180" align="center"> </el-table-column>

              <el-table-column label="操作" align="center">
                <template #default="{row}">
                  <span class="buttoned_box">
                    <el-button type="text" @click="edit_ed(row)" style="color:#409eff;font-weight: bold">编辑</el-button>
                    <span class="line"></span>
                    <el-button type="text" style="color:#FF7765;font-weight: bold" @click="del_fn(row)"
                      v-if="row.state == 0">删除</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="divider-line"></div>
          <div class="paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
              :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>

        </div>
      </div>
    </div>
    <!-- 新增修改 -->

    <el-dialog width="800px" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div style="display: flex;" class="dialog">
        <el-form :model="temp" ref="temp" :rules="rules" label-width="100px" style="padding-top: 10px; display: flex;
        flex-wrap: wrap;" :inline="true">
          <el-form-item label="表编号:" prop="cardNum">
            <el-input v-model="temp.cardNum" style=""></el-input>
          </el-form-item>
          <el-form-item label="表种类:" prop="remarks">
            <el-select v-model="temp.roleTypeId" placeholder="请选择">
              <el-option v-for="item in roleOptions" :key="item.id" :label="item.roleName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="表底数:" prop="remarks">
            <el-input v-model="temp.remarks"></el-input>
          </el-form-item>
          <el-form-item label="抄表日期:" prop="remarks">
            <el-date-picker v-model="temp.remarks" type="date" placeholder="选择日期"> </el-date-picker>
          </el-form-item>

          <el-form-item label="表类型:" prop="remarks">
            <el-select v-model="temp.roleTypeId" placeholder="请选择">
              <el-option v-for="item in roleOptions" :key="item.id" :label="item.roleName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="表型号:" prop="remarks">
            <el-input v-model="temp.remarks"></el-input>
          </el-form-item>
          <el-form-item label="抄表类型:" prop="remarks">
            <el-select v-model="temp.roleTypeId" placeholder="请选择">
              <el-option v-for="item in roleOptions" :key="item.id" :label="item.roleName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import elAreaTree from '@/components/module/newTree/elAreaTree.vue'
  import {findICCards,saveIcCard,deleteIcCard,icCardSaveExcel,findMeterType} from "../../api/zhongshanMeter";
  export default {
    components: {
      elAreaTree
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-280,//屏幕高度 - 导航栏高度
        seraname: "",
        tableData: [],
        loading: false,
        total: 0,
        currentPage: 1,
        currentSize: 15,
        //弹窗
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增水表档案",
          edit: "编辑水表档案"
        },
        //新增修改对象
        temp: {
          'cardNum': "",
          'remarks': "",
        },
        //星号必填
        rules: {
          cardNum: [
            {required: true,message: '请输入卡号',trigger: 'blur'}
          ]
        },
        roleOptions: [],
        typeList: []
      };
    },
    computed: {
      dataList () {
        var data=this.$store.unitStore.getters.getAreaTree
        return isempty(data)? []:[deviceList(data)]
      },

    },

    mounted () {
      this.getList()
      this.getTypeList() //获取表类型方式
    },
    watch: {
      dataList (v) {
        // console.log("侦听器",v);
      },
    },

    methods: {
      //获取表类型方式
      getTypeList () {
        findMeterType().then(res => {
          console.log(res);
          if(res.code==200) {
            this.typeList=res.data
          }
        })
      },
      // 添加弹窗
      add_ed (v) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

        // window.open('http://192.168.124.150:19002/#/newuserManager','_blank')

        // var startTime = $("#startTime").val();
        // var endTime = $("#endTime").val();
        // var dw = $("#dw").val();
        // window.location.href =ctx + "/travel/registrationSearch/export" + "?dw="+dw+"&beginRegTime=" + startTime+"&endRegTime=" + endTime;

        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            saveIcCard(this.temp).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })


          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp
            var d={
              "cardNum": data.cardNum,
              "id": data.id,
              "remarks": data.remarks,
            }
            saveIcCard(d).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('修改失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';

        this.temp=Object.assign({},v);

        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      //单个删除
      del_fn (row) {
        if(row.state==1) {
          this.$message({showClose: true,message: `此${row.cardNum}卡号已绑定，不可删除`,type: 'warning'});
          return
        }
        this.$confirm(`是否删除 ${row.cardNum}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteIcCard({"id": row.id}).then(res => {
            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });
      },
      //批量导入
      saveExcel_fn (file) {
        let data=new FormData();
        data.append("file",file.raw);
        //    this.loading = true
        icCardSaveExcel(data).then(res => {
          if(res.code==200) {
            this.getList()
            this.$message({showClose: true,message: res.data,type: 'success'});
          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加失败')

          }
        })
      },
      //获取数据
      getList () {

      },
      //分页功能
      newgetNowPageDataList () {
        this.getList()
        // 当前页显示
        // this.total = this.tableData.length;
        // var result = this.tableData.filter((item, index) => {
        //   return index < this.currentPage * this.currentSize && index >= (this.currentPage - 1) * this.currentSize;
        // });

        // this.nowPageDataList = result;
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .FilesManage {

    // background-color: #fff;
    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .left-tree {
      width: 3rem;
      height: 100%;
      flex-shrink: 0;
      overflow: hidden;
      background-color: #fff;
      padding: 20px 12px 12px 12px;
      box-sizing: border-box;
      margin-right: 8px;
    }


    .right-table {
      // width: 100%;
      flex-grow: 1;
      background-color: #fff;
      padding: 20px 20px 12px 20px;



      /deep/.search-input-btn .input-small .el-input {
        width: 150px;
      }

      .Files-table {
        margin-top: 20px;

        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table td {
          padding: 1px 0px;
          height: 44px;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
        margin-right: 15px;
        align-items: center;

      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }





  }
</style>